import { supabase } from '../supabase';

/**
 * Log an admin action to the audit trail
 *
 * @param {string} adminEmail - Email of the admin performing the action
 * @param {string} actionType - e.g. 'tier_change', 'role_change', 'user_removed', 'company_deleted', 'trial_extended', 'manual_credit', 'commission_paid', 'password_reset'
 * @param {string} targetType - e.g. 'company', 'user', 'affiliate', 'commission'
 * @param {string} targetId - UUID or identifier of the target
 * @param {string} targetName - Human-readable name (company name, user email, etc.)
 * @param {object} details - Additional context (old_value, new_value, reason, etc.)
 */
export async function logAdminAction(adminEmail, actionType, targetType, targetId, targetName, details = {}) {
  try {
    const { error } = await supabase
      .from('admin_actions')
      .insert({
        admin_email: adminEmail,
        action_type: actionType,
        target_type: targetType,
        target_id: targetId,
        target_name: targetName,
        details
      });

    if (error) {
      console.error('Failed to log admin action:', error.message);
    }
  } catch (e) {
    // Never let audit logging break the actual operation
    console.error('Audit log error:', e.message);
  }
}

/**
 * Fetch recent admin actions, optionally filtered
 */
export async function getAdminActions({ targetType, targetId, limit = 50 } = {}) {
  let query = supabase
    .from('admin_actions')
    .select('*')
    .order('created_at', { ascending: false })
    .limit(limit);

  if (targetType) query = query.eq('target_type', targetType);
  if (targetId) query = query.eq('target_id', targetId);

  const { data, error } = await query;
  if (error) {
    console.error('Failed to fetch admin actions:', error.message);
    return [];
  }
  return data || [];
}
